import { FormRenderProps } from "@progress/kendo-react-form";
import { pdf } from "@react-pdf/renderer";
import DateUtility from "../../../utilities/dateUtilities";
import { AccumulatorQuotePdf } from "./AccumulatorQuotePdf";
import { downloadBlobAsFile } from "./accumulatorQuotePdfDownload";

export interface AccumulatorQuotePdfExportParams {
  quote: any | null;
  quoteId: number;
  product: any;
  lookups: any;
  values: any;
  formRenderProps: FormRenderProps;
  instrumentType: any;
  gridResults: any[];
  underlying: number;
  isRiskTaker: boolean;
}

export async function exportAccumulatorQuotePdf(
  {
    quote,
    quoteId,
    product,
    lookups,
    values,
    formRenderProps,
    instrumentType,
    gridResults,
    underlying,
    isRiskTaker,
  }: AccumulatorQuotePdfExportParams,
  e?: { preventDefault?: () => void },
): Promise<void> {
  e?.preventDefault?.();
  if (!quote) return;

  const { company, commodity } = product;
  const knockOutType = lookups?.knockOutTypes?.find((d: any) => d.value === values.knockOutTypeId);
  const doubleUpType = lookups?.doubleUpTypes?.find((d: any) => d.value === values.doubleUpTypeId);
  const settlementType = lookups?.settlementTypes?.find(
    (d: any) => d.value === values.settlementTypeId,
  );
  const contractFormatted = DateUtility.formatDateMY(formRenderProps.valueGetter("contract"));

  const blob = await pdf(
    <AccumulatorQuotePdf
      quoteId={quoteId}
      quoteName={formRenderProps.valueGetter("quoteName") || ""}
      clientName={company?.name || ""}
      contract={contractFormatted}
      volume={values.volume}
      instrumentType={instrumentType?.text || ""}
      knockOutType={knockOutType?.text || ""}
      doubleUpType={doubleUpType?.text || ""}
      fixingFrequency={settlementType?.text || ""}
      quote={quote}
      gridResults={gridResults}
      underlying={underlying}
      commodity={commodity}
      isRiskTaker={isRiskTaker}
    />,
  ).toBlob();

  downloadBlobAsFile(blob, `accumulator-options-${quoteId}.pdf`);
}
